import { Suspense, lazy } from "react";

const TanStackRouterDevtools =
  process.env["NODE_ENV"] === "development"
    ? lazy(() =>
        // Lazy load in development
        import("@tanstack/router-devtools").then((res) => ({
          default: res.TanStackRouterDevtools,
          // For Embedded Mode
          // default: res.TanStackRouterDevtoolsPanel
        })),
      )
    : () => null; // Render nothing in production

export function RouterDevtools(props: { disable?: boolean }) {
  return (
    !props.disable && (
      <Suspense>
        <TanStackRouterDevtools />
      </Suspense>
    )
  );
}
